import SpecialistSessionReviewAPI from "api/SpecialistSessionReviewAPI";
import useFetchData from "hooks/useFetchData";

export default function useSpecialistSessionReviewsForSpecialist( params: SpecialistSessionReviewGETPaginatedParams = {}) {
   return useFetchData({
      APIMethod: SpecialistSessionReviewAPI.getAllForSpecialist,
      params: [ params ],
      debounce: true,
      clear_data_on_update: true
   })
}